import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { PackageBOMResponseModel } from 'projects/Administration/src/app/business-entities/package-list-model';
import { ItemStatusServicesModel, PartNumberMultiInventeryModel, PartsListViewModel } from 'projects/Administration/src/app/business-entities/parts-list-view-model';
import { ServicePackageBOM, ServiceViewModel } from 'projects/Administration/src/app/business-entities/service-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { CustomerService } from 'projects/Administration/src/app/business-services/customer.service';
import { DocumentService } from 'projects/Administration/src/app/business-services/document.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { PackageService } from 'projects/Administration/src/app/business-services/package.service';
import { PartsBusinessService } from 'projects/Administration/src/app/business-services/parts.service';
import { ServicesService } from 'projects/Administration/src/app/business-services/services.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { AppointmentDetail } from '../../../../../business-entities/appointmentDetail-model';
import { CustomerDropdownModel } from '../../../../../business-entities/customer-view.model';
import { LaborDetailsViewModel } from '../../../../../business-entities/labor-details-view-model';
import { AppointmentWorkOrderService } from '../../../../../business-services/appointment-work-order.service';
import { AppointmentService } from '../../../../../business-services/appointment.service';
import { LaborService } from '../../../../../business-services/labor.service';
import { CultureLocaleService } from '../../../../../services/culture-locale.service';
import { SearchLaborComponent } from '../../../../labor/search-labor/search-labor.component';
import { SearchPackageComponent } from '../../../../package/search-package/search-package.component';
import { SearchAlternatePartsComponent } from '../../../../parts/search-parts/search-alternate-parts/search-alternate-parts.component';
import { SearchPartsComponent } from '../../../../parts/search-parts/search-parts.component';
import { SearchReplacementPartsComponent } from '../../../../parts/search-parts/search-replacement-parts/search-replacement-parts.component';
import { SearchServiceComponent } from '../../../../services/search-service/search-service.component';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserRoleMenu } from 'projects/Administration/src/app/business-entities/user-role-menu.model';
import { UploadDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/upload-document/upload-document.component';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { ViewUploadedDocumentComponent } from 'projects/Autofacets-Core/src/app/views/UploadDocument/view-uploaded-document/view-uploaded-document.component';
import { AppointmentDemandList } from 'projects/Administration/src/app/business-entities/appointment-demand-list-view-model';
import { CustomerValidationComponent } from '../../../../widget-appointment-request/customer-validation/customer-validation.component';
import { environment } from 'projects/Administration/src/environments/environment';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { MechanicTimeCodeBusinessService } from 'projects/Administration/src/app/business-services/mechanic-time-code.service';
import { MultiStackPopupService } from 'projects/Administration/src/app/services/multi-stack-popup.service';
import { MechanicLineAssignmentDataService } from 'projects/Administration/src/app/data-services/mechanic-line-assignment-data.service';
import { EmployeeResource, MechanicLineAssignmentItem } from 'projects/Administration/src/app/business-entities/mechanic-line-assignment.model';
import { ServiceResourceAssignmentModalComponent } from 'projects/Administration/src/app/components/service-resource-assignment/service-resource-assignment-modal.component';


@Component({
  selector: 'app-work-order-services',
  templateUrl: './work-order-services.component.html',
  styleUrls: ['./work-order-services.component.css']
})
export class WorkOrderServicesComponent implements OnInit {
  @Input() appointmentServiceDetail: AppointmentServiceDetails;
  @Input() contactDetails: AppointmentDetail;
  @Output() updateServiceDetail = new EventEmitter<AppointmentServiceDetails>();
  @Output() openNewAppointment = new EventEmitter<number>();
  @Output() checkForSaveAppointment = new EventEmitter<void>();
  @Input() isOpenFromPlanning: boolean = false;
  popupCloseResult = false;
  services: ServiceViewModel[] = [];
  closeResult = '';
  dealerId: string = '';
  currency: string;
  packageList: any;
  formattedTotalTime: string = '0';
  VAT: number = 0;
  VatSub: Subscription;
  viewTotalInvoicePrice: number;
  totalTime: string;
  totalQuantity: string;
  selectAll: boolean = false;
  mainAppointmentServiceDetail: AppointmentServiceDetails;
  isFirstCall = 0;
  selectedPartList: PartsListViewModel[] = [];
  selectedLaborList: LaborDetailsViewModel[] = [];
  dealerServicesList: ServiceViewModel[] = [];
  packageVersionBOM: PackageBOMResponseModel[] = [];
  featureList: Features[] = [];
  isShowTax: boolean = false;
  isMaterialTaxVisible = true;
  customerList: CustomerDropdownModel[] = [];
  appointmentDetails: AppointmentList;
  personelDiscount: any;
  materialDiscount: any;
  isWarrantyDocumentSigned: boolean = false;
  disableShortDescriptionOnFilter: boolean = false;
  isDMSEnable: boolean = false;
  isDmsPackageSync: boolean = false;
  isRomnasEnabled: boolean = false;
  selectPackageMakeCode:string = "";
  selectPackageVersionName:string = "";
  isWarningLightFeature: boolean =false;
  viewDemandDocument:any = {};
  allowCustomerToUploadDoc:boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  documentSource:string = "";
  selectPackageSourceId:number = 0;
  isIntegrationWithParts:boolean = false;
  isToAddRentalCarAsDemand:boolean = false;
  currentlagSub:any;
  currentLanguage:any;
  CentralPart:boolean = false;
  hideServiceAsDemand:boolean = false;
  isMG:boolean = false;
  allAppointmentDemandList: Array<AppointmentDemandList>;
  appointmentDemandId:number;
  jobNo:number;
  jobDescription:string;
  jobStatus:number;
  jobShowStatus:string;
  tooltipPlacementForModal = 'top';
  tooltipPlacement = 'bottom';
  isAllSelectedForSplit = false;
  isMakeQuoteFromDemand: boolean = false;
  splitOrderInstance: any;
  splitOrderModalRef: NgbModalRef | null = null;
  splitOrderPopupContent: any;
  appointmentSplitDemandList:any = [];
  showItemStatusIcon = true;
   isMechanicLineAssignmentEnabled: boolean = false;
  isMechanicLineAssignmentInDmsEnabled: boolean = false;
  employeeResources: EmployeeResource[] = [];
  private mechanicAssignmentMap: Map<number, MechanicLineAssignmentItem[]> = new Map();

  constructor(public workOrderService: AppointmentWorkOrderService,
    private readonly modalService: NgbModal,
    private readonly translate: TranslateService,
    public editAppointmentService: EditAppointmentService,
    private readonly spinner: NgxSpinnerService,
    private readonly appointmentService: AppointmentService,
    public settingService: SettingService,
    private readonly toastr: ToastrService,
    private readonly packageService: PackageService,
    private readonly currentLanguageService: CurrentLanguage,
    public cultureLocaleService: CultureLocaleService,
    private readonly partService: PartsBusinessService,
    private readonly serviceServices: ServicesService,
    private readonly laborService: LaborService,
    private readonly cookieservice: CookieService,
    private readonly secureStorage: SecureStorage,
    private readonly globalSetting: GlobalSetting,
    private readonly customerService: CustomerService,
    private readonly documentService: DocumentService,
    private readonly userService: UserDataService,
    private readonly commonService: CommonService,
    private readonly service: MechanicTimeCodeBusinessService,
    private readonly appointmentCommonService: AppointmentCommonService,
    private readonly multiStackPopupService: MultiStackPopupService,
    private readonly workOrderAdditionalService: AppointmentWorkOrderService,
    private readonly cdr: ChangeDetectorRef,
    private readonly mechanicLineAssignmentDataService: MechanicLineAssignmentDataService
  ) {
    this.totalTime = this.translate.instant("lblTotalTime");
    this.totalQuantity = this.translate.instant("lblTotalQty");
  }

  public get isDemandSelectedToSplit(): boolean {
    return this.appointmentServiceDetail?.appointmentDemandList?.some(x => x.isSelected) ?? false;
  }

  public get isSplitOrderDisabled() {
    return !(this.editAppointmentService.isEdit && 
      this.appointmentServiceDetail?.appointmentDemandList && this.appointmentServiceDetail.appointmentDemandList?.length > 0 &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 3 &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 5 && 
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 6 &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 7 &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 9 &&
      this.editAppointmentService.appointmentDetails.workOrderStatusId !== 10);
  }

  ngOnInit(): void {
    if (localStorage.getItem("Theme") === 'mg') {
      this.hideServiceAsDemand = true;
      this.isMaterialTaxVisible = false;
      this.isMG = true;
    }
    this.getFeatures();
    this.VatSub = this.currentLanguageService.vatSubject.subscribe(x => {
      this.VAT = x;
    })
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x;
    });
    this.currency = this.settingService.currencySymbol;
    if (this.appointmentServiceDetail?.appointmentDemandList && this.appointmentServiceDetail?.appointmentDemandList.length > 0) {
      this.workOrderService.totalInvoicePrice = this.workOrderService.totalPrice - (this.workOrderService?.contactDetails?.discount !== undefined ?
        ((this.workOrderService?.totalPrice *
          this.workOrderService.contactDetails.discount) / 100) : 0);
      this.formattedTotalTime = this.workOrderService.totalTime.toFixed(2);
    }
    this.workOrderService.isJobDetailDiscountError = false;
    
    this.GetWarrantyDocumentStatus();
    this.getCustomerList();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.CustomerDocumentUpload);
    this.loadEmployeeResources();
  }
  async getCustomerList() {
    this.spinner.show();
    await this.customerService.getCustomerDropdownByLicensePlateNo(this.editAppointmentService.appointmentDetails.licensePlate,this.editAppointmentService.appointmentDetails?.id).then((response) => {
      this.spinner.hide();
      this.customerList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }

  async loadEmployeeResources(): Promise<void> {
    try {
      const response = await this.mechanicLineAssignmentDataService.getEmployeeResources();
      this.employeeResources = response?.responseObject || [];
    } catch {
      this.employeeResources = [];
    }
  }

  OpenCustomerValidation(index,isWidgetData: boolean): void {
    const modalref = this.modalService.open(CustomerValidationComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'pop-wid1366 CustomCardPopup',
    });
    
    modalref.componentInstance.isFromEditAppointment = isWidgetData
    modalref.result.then(
      (response) => {
        if (response.success) {
          this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer = response.customer.customerNo
          this.appointmentServiceDetail.appointmentDemandList[index].billToCustomerName = response.customer.customerName
        }
      }
    );
  }

  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isShowTax = this.featureList.find(x => x.featureCode === Enums.FeatureCode.Tax)?.isActive;
        this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.isDmsPackageSync = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
        this.isRomnasEnabled = this.featureList.find(x => x.featureCode === Enums.FeatureCode.Romnas)?.isActive;
        this.CentralPart = this.featureList.find(x => x.featureCode === Enums.FeatureCode.CentralPart)?.isActive;
        if(this.featureList.find(x => x.featureCode === Enums.FeatureCode.WarningLight))
        this.isWarningLightFeature=this.featureList.find(x => x.featureCode === Enums.FeatureCode.WarningLight)?.isActive;
        this.allowCustomerToUploadDoc=this.featureList.find(x => x.featureCode === Enums.FeatureCode.AllowCustomerUploadDoc)?.isActive;
        this.isIntegrationWithParts = this.featureList.find(x=> x.featureCode === Enums.FeatureCode.PARTS)?.isActive;
        this.isToAddRentalCarAsDemand = this.featureList.find(x=> x.featureCode === Enums.FeatureCode.RentalCarAsDemand)?.isActive;
        this.isMakeQuoteFromDemand = this.featureList.find(x=> x.featureCode === Enums.FeatureCode.MakeQuoteFromDemand)?.isActive;
        this.isMechanicLineAssignmentEnabled = this.featureList.find(x => x.featureCode === Enums.FeatureCode.EnableMechanicLineAssignment)?.isActive ?? false;
        this.isMechanicLineAssignmentInDmsEnabled = this.featureList.find(x => x.featureCode === Enums.FeatureCode.MechanicLineAssignmentInDms)?.isActive ?? false;
        if (this.isMechanicLineAssignmentEnabled) {
        this.loadMechanicAssignments();
        }
      }
    }
  }

   async loadMechanicAssignments(): Promise<void> {
    const appointmentId = this.editAppointmentService.appointmentDetails?.id;
    if (!appointmentId) return;
    try {
      const response = await this.mechanicLineAssignmentDataService.getMechanicLineAssignment(appointmentId);
      this.mechanicAssignmentMap = new Map();
      if (response?.responseObject) {
        for (const item of response.responseObject) {
          if (item.appointmentJobDetailId) {
            const existing = this.mechanicAssignmentMap.get(item.appointmentJobDetailId) ?? [];
            existing.push(item);
            this.mechanicAssignmentMap.set(item.appointmentJobDetailId, existing);
          }
        }
      }
    } catch {
      // silently ignore — feature is additive, grid still works without it
    }
  }

  getResourceCount(jobDetailId: number): number {
    return this.mechanicAssignmentMap.get(jobDetailId)?.length ?? 0;
  }

  isJobDetailSynced(jobDetailId: number): boolean {
    const assignments = this.mechanicAssignmentMap.get(jobDetailId) ?? [];
    if (assignments.length === 0) return true;
    return assignments.every(a => a.dmsSyncStatus === 1);
  }


  isResourceAssignmentBlockedByDms(jobdetail: any): boolean {
    return this.isDMSEnable && this.isMechanicLineAssignmentInDmsEnabled && !jobdetail.dmsLineNo;
  }

  openResourceAssignment(jobdetail: any): void {
    if (this.isResourceAssignmentBlockedByDms(jobdetail)) {
      this.toastr.warning(this.translate.instant('lblLineNotSyncedToDms'));
      return;
    }
    const assignments = this.mechanicAssignmentMap.get(jobdetail.id) ?? [];
    const modalRef = this.modalService.open(ServiceResourceAssignmentModalComponent, {
      size: 'lg',
      windowClass: 'pop-wid900',
      backdrop: 'static'
    });
    const inst = modalRef.componentInstance as ServiceResourceAssignmentModalComponent;
    inst.appointmentId = jobdetail.appointmentId;
    inst.appointmentJobId = jobdetail.appointmentJobId;
    inst.appointmentJobDetailId = jobdetail.id;
    inst.ifsWorkOrderNumber = this.editAppointmentService.appointmentDetails?.workOrderNo ?? '';
    inst.dmsJobLineNo = jobdetail.dmsJobLineNo ?? '';
    inst.dmsLineNo = jobdetail.dmsLineNo ?? '';
    inst.lineLabel = `${jobdetail.demandNo}/${jobdetail.jobDetailsId} — ${jobdetail.description}`;
    inst.demandNo = jobdetail.demandNo;
    inst.jobDetailId = jobdetail.jobDetailsId;
    inst.costType = jobdetail.costType ?? '';
    inst.qty = jobdetail.plannedQuantity;
    inst.existingAssignments = assignments;
    inst.availableResources = this.employeeResources;
    inst.isMechanicLineAssignmentInDmsEnabled = this.isMechanicLineAssignmentInDmsEnabled;
    inst.isReadOnly = this.editAppointmentService.appointmentDetails?.isFromArchive ||
      this.editAppointmentService.appointmentDetails?.workOrderStatusId === Enums.WOStatus.Invoiceready;

    modalRef.result.then((savedRows) => {
      if (savedRows) {
        // Rebuild the assignment map entry for this line — include sync fields so icon state is correct
        const updatedItems: MechanicLineAssignmentItem[] = savedRows.map((r: any) => ({
          ifsWorkOrderNumber: this.editAppointmentService.appointmentDetails?.workOrderNo ?? '',
          dmsJobLineNo: jobdetail.dmsJobLineNo ?? '',
          dmsLineNo: jobdetail.dmsLineNo ?? '',
          employeeNo: r.employeeNo,
          portionPercent: r.portionPercent,
          dmsSyncStatus: r.dmsSyncStatus,
          dmsSyncDate: r.dmsSyncDate,
          isManual: true,
          appointmentId: jobdetail.appointmentId,
          appointmentJobId: jobdetail.appointmentJobId,
          appointmentJobDetailId: jobdetail.id
        }));
        this.mechanicAssignmentMap.set(jobdetail.id, updatedItems);
        // Keep primaryEmployeeNo in sync — first row is the primary resource
        jobdetail.primaryEmployeeNo = savedRows.length > 0 ? savedRows[0].employeeNo : null;
      }
    }).catch(() => { });
  }


  onBlurPersonnelDiscount(event) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseInt(value) <= 0 || parseInt(value) >= 100) {
      this.workOrderService.isJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderService.isJobDetailDiscountError = false;
    this.personelDiscount = event.target.value;
    this.appointmentServiceDetail?.appointmentJobDetailList.forEach(jobDetail => {
      if (jobDetail.costType === 'Personnel')
        jobDetail.discount = event.target.value;
    });

  }

  onBlurMaterialDiscount(event) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseInt(value) <= 0 || parseInt(value) >= 100) {
      this.workOrderService.isJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderService.isJobDetailDiscountError = false;
    this.materialDiscount = event.target.value;
    this.appointmentServiceDetail?.appointmentJobDetailList.forEach(jobDetail => {
      if (jobDetail.costType === 'Material')
        jobDetail.discount = event.target.value;
    });
  }



  addFilterSelectedVariable(toSelect: boolean) {
    this.disableShortDescriptionOnFilter=false;
    this.appointmentServiceDetail.appointmentDemandList.forEach((obj) => {
      obj.isFilterSelected = toSelect;
    });
    this.appointmentServiceDetail.appointmentJobList.forEach((obj) => {
      obj.isFilterSelected = toSelect;
      let jobDetails = this.workOrderService.appointmentJobDetailToUpdate?.find((detail) => detail.jobId == obj.jobId && detail.costType == 'Personnel');
      if(jobDetails != null || jobDetails != undefined){
        obj.isServiceAdded = true;
      }
    });
    this.mainAppointmentServiceDetail = Object.assign({}, this.appointmentServiceDetail);
  }

  checkValue(demand: any) {
    if (demand.sentForCustomerApproval) {
      demand.customerReply = 'Pending';
    }
    else {
      demand.customerReply = null;
    }
  }

  checkWarranty(i: number) {
    if (!this.appointmentServiceDetail.appointmentDemandList[i].isInWarranty) {
      let makeCode = this.contactDetails.companyMakeCode;

      let index = this.customerList.findIndex(x=>x.customerNo.includes(makeCode) && x.customerGroup == "GARANTI")
      if(index >= 0){
        this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.customerList[index].customerNo;
      }else{
        let indexDefault = this.customerList.findIndex(x=>x.customerNo == "INT-BB GARANTI-12")
        if(indexDefault >= 0){
          this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.customerList[indexDefault].customerNo;
        }
      }
    }
    else {
      this.appointmentServiceDetail.appointmentDemandList[i].billToCustomer = this.contactDetails.billtoCustomerNo;
    }
  }

  onBlurShortDescription(index: number) {
    if(!this.disableShortDescriptionOnFilter){
      this.mapJobWithDemand(index);
    }
  }
  isQtyPrice(event, value) {
    if (!this.cultureLocaleService.isQtyPrice(event, value)) {
      let msg = this.translate.instant("lblValidValue");
      this.toastr.error(msg)
      event.preventDefault();
    }
  }
  onBlurUnitPrice(event,index) {
    let unitPrice= JSON.parse(JSON.stringify(event.target.value));
    //parseFloat(unitPrice.toString().replace('\u00A0', '').replace(' ',''))
    unitPrice = parseFloat(unitPrice.toString().replace('\u00A0', '').replace(' ','').replace(',','.'));
    this.appointmentServiceDetail.appointmentJobDetailList[index].unitPrice = unitPrice;
  }
  onBlurCustomerDiscount(event) {
    if (event >= 0 && event <= 100) {
      this.workOrderService.isDiscountError = false;
      this.workOrderService.contactDetails.discount = event;
      this.workOrderService.totalInvoicePrice = this.workOrderService.totalPrice -
        ((this.workOrderService.totalPrice *
          this.workOrderService.contactDetails.discount) / 100);
    }
    else {
      this.workOrderService.isDiscountError = true;
      let errorMessage = this.translate.instant("lblDiscountValidation");
      this.toastr.error(errorMessage);
    }
  }

  onBlur(event, index: number, type: string) {
    if (type == "Demands") {
      this.appointmentServiceDetail.appointmentDemandList[index].fixedPrice = event.target.value;
    }
    else if (type == "JobDetails") {
      this.appointmentServiceDetail.appointmentJobDetailList[index].fixedPrice = event.target.value;
    }
  }

  onBlurDiscount(event, index: number) {
    let value = this.globalSetting.getFormattedprice(event.target.value);
    if (parseFloat(value) < 0.01 || parseFloat(value) > 100) {
      this.workOrderService.isJobDetailDiscountError = true;
      let msg = this.translate.instant("lblValidInputForDiscount")
      this.toastr.error(msg);
      return;
    }
    this.workOrderService.isJobDetailDiscountError = false;
    if (!this.empty(this.appointmentServiceDetail.appointmentJobDetailList[index].fixedPrice)) {
      const previousDiscount = this.appointmentServiceDetail.appointmentJobDetailList[index].discount;
      const newValue = event.target.value;
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = this.translate.instant("lblConfirmation");
      modalRef.componentInstance.modelBody = this.translate.instant("lblDiscountChangeWithFixedPriceWarning");
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.appointmentServiceDetail.appointmentJobDetailList[index].discount = newValue;
        } else {
          event.target.value = previousDiscount;
        }
      });
      return;
    }
    this.appointmentServiceDetail.appointmentJobDetailList[index].discount = event.target.value;
  }

  mapJobWithDemand(index: number) {
    if (index < this.appointmentServiceDetail.appointmentJobList.length) {
      let customerrequirment = this.appointmentServiceDetail.appointmentDemandList[index].shortDescription;
      this.appointmentServiceDetail.appointmentJobList[index].description = customerrequirment;
    }
    else {
      let shortdescription: any = this.appointmentServiceDetail.appointmentDemandList[index].shortDescription.toString();
      let lastDemandNo: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNo,
        jobId: lastDemandNo,
        description: shortdescription,
        appointmentDemandId: 0,
        fixedPrice: null,
        price: 0,
        salesPriceWithoutDiscountInclVAT:0,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: false
      });
    }
  }
  emitServiceData() {
    this.workOrderService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
    this.workOrderService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
    this.workOrderService.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList;
    this.workOrderService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
  }
  AddDemand() {
    
    if(this.disableShortDescriptionOnFilter){
      let msg = this.translate.instant("lblClearFilterToAddDemand")
      this.toastr.error(msg);
    }
    else{
      if (this.appointmentServiceDetail.appointmentDemandList.length == 0) {
        
        this.appointmentServiceDetail.appointmentDemandList.push({
          id: 0,
          demandNo: 1,
          shortDescription: "",
          customerRequirement: "",
          preApproval: "",
          isAddedFromAdmin: true,
          isInWarranty: false,
          isDeleted: false,
          fixedPrice: null,
          sumPerService: 0,
          sumPerServiceInclTax: 0,
          sentForCustomerApproval: false,
          customerReply: null,
          isAdditionalWork: false,
          totalPriceInclVAT:0,
          sumPerServiceWithoutDiscountInclVAT:0,
          billToCustomer:this.contactDetails.billtoCustomerNo,
          docCount:0,
          sstOperationId : '',
          sstOperationCode: '',
          demandStaus:''
        });
      }
      else {
        if (!this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription))
        {
          let lastDemandNo: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
          lastDemandNo = lastDemandNo + 1;
          this.appointmentServiceDetail.appointmentDemandList.push({
          id: 0,
          demandNo: +lastDemandNo,
          shortDescription: "",
          customerRequirement: "",
          preApproval: "",
          isAddedFromAdmin: true,
          isInWarranty: false,
          isDeleted: false,
          fixedPrice: null,
          sumPerService: 0,
          sumPerServiceInclTax: 0,
          sumPerServiceWithoutDiscountInclVAT:0,
          sentForCustomerApproval: false,
          customerReply: null,
          isAdditionalWork: false,
          totalPriceInclVAT:0,
          billToCustomer:this.contactDetails.billtoCustomerNo,
          docCount:0,
          sstOperationId : '',
          sstOperationCode: '',
          demandStaus:''
        });
      }
      else{
        let msg = this.translate.instant("lblShortDescriptionNotNull")
        this.toastr.error(msg);
      }
    }
    }
  }
  deleteJobDetail(index: number,jobDetailId:number) {
    //in case filter is applied on demand level or job level use jobdetailId 
    let isFilteredSelected=false;
    if(this.appointmentServiceDetail.appointmentJobList.find(x=>x.isFilterSelected===true))
    {
      isFilteredSelected=true;
    }
    let modelHeadermsg = this.translate.instant("lblDelete");

    let modelBodymsg  = "";
    if(this.secureStorage.getKeyData('ApplyDiscountOnFixedPriceReverse') == "1"){
      let jobId = this.appointmentServiceDetail.appointmentJobDetailList.filter(f=>f.id == jobDetailId)[0].appointmentJobId;
      let demandId = this.appointmentServiceDetail.appointmentJobList.filter(f=>f.id == jobId)[0].appointmentDemandId;
      if (!this.empty(this.appointmentServiceDetail.appointmentDemandList.filter(f=>f.id == demandId)[0].fixedPrice)) {
        modelBodymsg = Utility.createMessage(this.translate.instant("lblDeleteJobDetailsFixedPriceValidation"), this.translate.instant("lblJobDetail"), true);
      }else{
        modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblJobDetail"), true);
      }
     }else{
      modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblJobDetail"), true);
     }
    
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if(isFilteredSelected)
        {
          index=this.workOrderService.appointmentJobDetailToUpdate.findIndex(x=>x.id===jobDetailId);
        }
        this.workOrderService.appointmentJobDetailToUpdate[index].isDeleted = true;
        this.DeleteAndGetJobDetails();
      }
    });
  }

  ViewComment(comment) {
    let msg = comment
    let modelHeadermsg = this.translate.instant("lblCustomerComment");
    const modalRef = this.modalService.open(NgInfoModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = msg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
    });
  }
  DeletePackage(index: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblPackage"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.workOrderService.appointmentJobDetailToUpdate.length) {
          let packageNo = this.workOrderService.appointmentJobList[index].packageNo;
          let packageVersionNo = this.workOrderService.appointmentJobList[index].packageVersionNo;
          let demandNo = this.workOrderService.appointmentJobList[index].demandNo;
          let jobId = this.workOrderService.appointmentJobList[index].id;
          this.workOrderService.appointmentJobDetailToUpdate.forEach(x => {
            if (x.appointmentJobId == jobId && x.demandNo == demandNo && x.packageNo == packageNo && x.packageVersionNo == packageVersionNo) {
              x.isDeleted = true;
            }
          })
          this.workOrderService.appointmentJobList[index].packageNo = '';
          this.workOrderService.appointmentJobList[index].packageVersionNo = 0;
          this.DeleteAndGetJobDetails();
        }else{
          this.workOrderService.appointmentJobList[index].packageNo = '';
          this.workOrderService.appointmentJobList[index].packageVersionNo = 0;
          this.DeleteAndGetJobDetails();
        }
      }
    });
  }
  async deleteDemand(deleteAll: boolean, index?: number) {
    if(this.disableShortDescriptionOnFilter){
      let msg = this.translate.instant("lblClearFilterToDeleteDemand")
      this.toastr.error(msg);
      return
    }
    if (this.isWarrantyDocumentSigned && this.appointmentServiceDetail.appointmentDemandList[index].isInWarranty) {
      let modelHeadermsg = this.translate.instant("lblDocumentAlreadySigned");
      let modelBodymsg = this.translate.instant("lblWarrantyCanNotDelete");
      const modalRef = this.modalService.open(NgInfoModalContent, { size: 'lg' });
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
    }
    else{
      let jobDetailsList = "";
      this.appointmentServiceDetail.appointmentJobDetailList.forEach(x => {
        if (x.demandNo == this.appointmentServiceDetail.appointmentDemandList[index].demandNo) {
          jobDetailsList = jobDetailsList == "" ? x.id.toString() : (jobDetailsList + "," + x.id).toString()
        }
      })
      let model = {
        DemandNumber: this.appointmentServiceDetail.appointmentJobList[index].demandNo,
        IFSWorkOrderNumber: this.editAppointmentService.appointmentDetails.workOrderNo,
        AppointmentId: this.editAppointmentService.appointmentDetails.appointmentId,
        JobNumberList: this.appointmentServiceDetail.appointmentJobList[index].id,
        JobDetailNumberList: jobDetailsList
      }
      let response = await this.appointmentService.GetClockinDemandDetails(model);
      let modelHeadermsg = this.translate.instant("lblDelete");
      let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblDemands"), false);
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      if(response.clockInCount > 0){
        let clockInMessage = this.translate.instant("lblMechanicHaveClockIn");
        clockInMessage = clockInMessage.replace('{mechanicName}',response.clockInMechanicName);
        modalRef.componentInstance.warningBody = clockInMessage;
      }
      modalRef.result.then((_result) => {
        // This is intentional
        }, (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          let isReload = true;
          if (!deleteAll) {
            if (this.isToAddRentalCarAsDemand && this.appointmentServiceDetail.appointmentDemandList[index].isRentalCarDemand) {
              this.appointmentCommonService.contactDetails.isRentalCarSelected = false;
            }
            const demandId = this.appointmentServiceDetail.appointmentDemandList[index].id;
            let demandNo = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
            if (demandId == 0) {
              if (this.appointmentServiceDetail.appointmentJobList.length !== 0 && index < this.appointmentServiceDetail.appointmentJobList.length) {
                if (demandNo) {
                  if (this.appointmentServiceDetail.appointmentJobDetailList.length !== 0) {
                    this.appointmentServiceDetail.appointmentJobDetailList = this.appointmentServiceDetail.appointmentJobDetailList.filter(x => x.demandNo != demandNo);
                    this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
                    this.appointmentServiceDetail.appointmentJobList.splice(index, 1);
                    this.workOrderService.appointmentJobDetailToUpdate = this.workOrderService.appointmentJobDetailToUpdate.filter(x => x.demandNo != demandNo);
                    isReload = false;
                  }
                  else {
                    this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
                    this.appointmentServiceDetail.appointmentJobList.splice(index, 1);

                  }

                }
                else {
                  this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
                }
              }
              else {
                isReload = false;
                this.appointmentServiceDetail.appointmentDemandList.splice(index, 1);
              }
            }
            else {
              this.workOrderService.appointmentDemandList[index].isDeleted = true;
              this.workOrderService.appointmentJobList[index].isDeleted = true;
              //if (index > this.workOrderService.appointmentJobDetailToUpdate.length) {
                this.workOrderService.appointmentJobDetailToUpdate.forEach(x => {
                  if (x.demandNo == demandNo) {
                    x.isDeleted = true;
                  }
                })
              // }
              // else {
              //   this.workOrderService.appointmentDemandList[index].isDeleted = true;
              //   this.workOrderService.appointmentJobList[index].isDeleted = true;
              // }
            }
          } else {
            this.workOrderService.appointmentDemandList.forEach((obj) => obj.isDeleted = true);
            this.selectAll = false;
            if (this.isToAddRentalCarAsDemand) {
              this.appointmentCommonService.contactDetails.isRentalCarSelected = false;
            }
          }
          if (isReload) {
            this.DeleteAndGetJobDetails();
          }
        }
      });
    }
  }

  async OpenSearchServicesPopUp(index: number,isServiceAsDemand) {
    if(!isServiceAsDemand)
    {
      if (this.empty(this.appointmentServiceDetail.appointmentDemandList[index]?.shortDescription)) {
        let msg = this.translate.instant("lblJobDescNotNull")
        this.toastr.error(msg);
        return;
      }
      let demandIndexFixed=this.getDemandIndex(index);
      if (this.secureStorage.getKeyData('ApplyDiscountOnFixedPriceReverse') == "1" && !this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndexFixed]?.fixedPrice)) {
        let msg = this.translate.instant("lblDemandFixedPriceValidation")
        this.toastr.error(msg);
        return;
      }
    } else if (isServiceAsDemand && this.appointmentServiceDetail.appointmentDemandList?.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
   let demandIndex=index;
   if (isServiceAsDemand){
     index = this.appointmentServiceDetail.appointmentDemandList.length;
     demandIndex = index;
   }
    if(index===0 && this.appointmentServiceDetail.appointmentDemandList.find(x=>x.isFilterSelected===true))
    {
      demandIndex=this.appointmentServiceDetail.appointmentDemandList.findIndex(x=>x.isFilterSelected===true);
    }

    this.services = [];
    this.serviceServices.registrationDate = this.contactDetails.registrationDate;
    this.serviceServices.engineTypeCode = this.contactDetails.engineTypeCode;
    this.serviceServices.vehicleTypeCode = this.contactDetails.vehicleTypeCode;
    this.serviceServices.companyMakeCode = this.contactDetails.companyMakeCode;
    this.serviceServices.model = this.contactDetails.modelName;
    this.serviceServices.previousKilometer = this.contactDetails.previousKilometer;
    this.serviceServices.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    this.serviceServices.locationCode = this.contactDetails.locationCode;
    this.serviceServices.customerNo = isServiceAsDemand? this.contactDetails.billtoCustomerNo : this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index]?.jobId;

    const modalRef = this.modalService.open(SearchServiceComponent, {
      windowClass: 'pop-wid1366',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    // let selectedServiceIdArray = (this.disableShortDescriptionOnFilter)?this.mainAppointmentServiceDetail?.appointmentJobDetailList.map((x) => x.serviceId):this.appointmentServiceDetail?.appointmentJobDetailList.map((x) => x.serviceId);
    // modalRef.componentInstance.selectedServiceIdArray = selectedServiceIdArray;
    modalRef.result.then((_result) => {
      // This is intentional
     }, async (reason) => {
      this.services = this.serviceServices.SelectedServices;
      let serviceExits = false;
      if(!isServiceAsDemand){  
        for (const item of this.services) {
          if (this.appointmentServiceDetail.appointmentJobDetailList.findIndex(y => y.jobId == currentJobId && y.bomTypeId == 1 && y.salesPart == item.serviceNo && y.serviceId == item.id) != -1) {
            serviceExits = true;
          }
        }
      }

      if (serviceExits && reason === true) {
        let serviceErrorMessage = this.translate.instant("lblServiceAlreadyExists");
        this.toastr.error(serviceErrorMessage);
        modalRef.dismiss(true);
        this.disableShortDescriptionOnFilter = false;
      } else {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          if (isServiceAsDemand === false) {
            this.disableShortDescriptionOnFilter = false;

            await this.mapJobWithJobDetails(index, demandIndex, false);
          } else {
            await this.GetServiceAsDemand();
            await this.mapJobWithJobDetails(index, demandIndex, false);
          }

          this.cdr.detectChanges();
      }
      }
    })
  }

  async mapJobWithJobDetails(index: number,demandIndex:number, flag) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[demandIndex].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    if (!flag) {
      this.workOrderService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
    }
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    let isAddedFromAdmin = this.appointmentServiceDetail.appointmentJobList[index].isAddedFromAdmin;
    let warningLightNameForJobDemand='';
    this.services.forEach(x => {
        let selectedWarningLightId='';
        if(x.isWarningLight && this.isWarningLightFeature)
        {
          let warningLightName='';
          warningLightName=' - ';
          x.warningLightService.forEach(element => {
            if(element.isSelected)
            {
              selectedWarningLightId+=element.id+',';
              warningLightName=warningLightName+ element.warningLightName+', ';
            }

          });
          warningLightNameForJobDemand=warningLightNameForJobDemand+warningLightName;
        }
        this.workOrderService.appointmentJobDetailToUpdate.push({
          jobDetailsId:0,
          appointmentId: this.editAppointmentService.appointmentDetails.id,
          appointmentJobId: appointmentJobId ? appointmentJobId : 0,
          costType: "Personnel",
          demandNo: demand,
          description:warningLightNameForJobDemand!==''? x.name+warningLightNameForJobDemand :x.name ,
          fixedPrice: x.isFixed && x.servicePrice ? x.servicePrice: null,
          id: 0,
          jobId: job,
          plannedQuantity: 0,
          salesPart: x.serviceNo,
          salesPriceWithoutDiscount:0,
          salesPriceWithoutDiscountInclVAT:0,
          salesPriceAmount: 0,
          salesPriceAmountVAT: 0,
          serviceId: x.id,
          unitPrice: 0,
          quantity: x.duration,
          isAddedFromAdmin: isAddedFromAdmin,
          isAdditionalWork: false,
          bomTypeId: 1,
          partTotalQtyOnLocal: 0,
          partAvailableQtyOnHand: 0,
          partAvailableQtyOnCentral: 0,
          discount:  null,
          discountPrice: null,
          packageNo: null,
          packageVersionNo: 0,
          billToCustomer:billToCustomer,
          makeCode: x.makeCode,
          selectedWarningLightId:selectedWarningLightId,
          costPrice:0,
          itemGroupCode:"",
          lastDirectCost:0,
          listPriceLCY:0,
          itemStatusId: 0
        });
      if(!this.empty(x.aFxPackageNo)){
        if(x.servicePackageBOM.length > 0){
          this.saveSearchedServiceBOMDetails(index,x.servicePackageBOM);
        }
      }
      this.appointmentServiceDetail.appointmentJobList[index].description= warningLightNameForJobDemand!==''? this.appointmentServiceDetail.appointmentJobList[index].description+warningLightNameForJobDemand :this.appointmentServiceDetail.appointmentJobList[index].description;
      this.appointmentServiceDetail.appointmentDemandList[demandIndex].customerRequirement= warningLightNameForJobDemand!==''? x.internalDescription+warningLightNameForJobDemand :x.internalDescription;
      this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription= warningLightNameForJobDemand!==''? this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription+warningLightNameForJobDemand :this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription;
    });
    this.services.forEach(x => {
      x.isServiceChecked = false;
    })
    await this.GetJobsDetailsList();
  }

  async saveSearchedServiceBOMDetails(index: number, serviceBOM: ServicePackageBOM[]) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
   
    serviceBOM.filter(x => x.bomTypeId == 2).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.totalQuantityOnLocal  ?? 0 ,
        partAvailableQtyOnHand: x.availableQuantity ?? 0 ,
        partAvailableQtyOnCentral: x.centralAvailableQty  ?? 0 ,
        discount: null,
        discountPrice: null,
        packageNo: '',
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: '',
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 1).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId ? appointmentJobId : 0,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: x.serviceId,
        unitPrice: 0,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 1,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: '',
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: '',
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 3).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        packageNo: '',
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: '',
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    serviceBOM.filter(x => x.bomTypeId == 4).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: "",
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 4,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: '',
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: '',
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
  }


  async GetAppointmentServiceDetails(){
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '').then(data => {
      if (data.responseObject.errorCount > 0) {
        this.appointmentServiceDetail = {
          totalPrice: 0,
          totalTime: 0,
          totalInvoicePrice: 0,
          rentalCompanyMakeName:'',
          priceForDisply:'',
          appointmentDemandList: [],
          appointmentJobDetailList: [],
          appointmentJobList: [],
          appointmentPriceDetails: []
        }
        this.workOrderService.totalPrice = null;
        this.workOrderService.totalTime = null;
        this.workOrderService.totalInvoicePrice = null;
      }
      else {
        this.appointmentServiceDetail = data.responseObject;
        this.updateServiceDetail.emit(this.appointmentServiceDetail);
        this.mapIndexWithJobDetails();
        this.workOrderService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
        this.workOrderService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
        this.workOrderService.totalPrice = this.appointmentServiceDetail.totalPrice;
        this.workOrderService.totalPrice = 0;
        this.workOrderService.totalPriceInclVAT = 0;
        this.workOrderService.totalInvoicePrice = 0;
        if (this.appointmentServiceDetail.taxDetail) {
          this.workOrderService.taxDetail = this.appointmentServiceDetail.taxDetail;
          this.workOrderService.totalPrice = this.appointmentServiceDetail.taxDetail.totalPriceInclTAX;
          this.workOrderService.totalInvoicePrice = this.appointmentServiceDetail.taxDetail.totalInvoicePrice;
          this.workOrderService.totalPriceInclVAT = this.appointmentServiceDetail.taxDetail.salesPriceInclVAT;
          this.workOrderService.getOverallAmountForAppointment();
        }
        this.workOrderService.totalTime = this.appointmentServiceDetail.totalTime;
        this.formattedTotalTime = Number(this.workOrderService.totalTime).toFixed(2);
        this.workOrderService.appointmentJobDetailToUpdate = this.appointmentServiceDetail.appointmentJobDetailList.slice();
      }
      this.addFilterSelectedVariable(false);
    })
  }

  async GetServiceAsDemand() {
    //demand as service
    let selectedService: any[] = [];
    this.services.forEach(x => {
      if (x.isServiceChecked) {
        selectedService.push(x);
      }
    })
    if (this.appointmentServiceDetail.appointmentDemandList.length == 0) {
      this.appointmentServiceDetail.appointmentDemandList.push({
        id: 0,
        demandNo: 1,
        shortDescription: selectedService[0].name,
        customerRequirement: selectedService[0].internalDescription,
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedService[0].price,
        sumPerServiceInclTax: selectedService[0].price,
        sumPerServiceWithoutDiscountInclVAT:selectedService[0].price,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      });
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: 1,
        jobId: 1,
        description: selectedService[0].name,
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedService[0].price,
        salesPriceWithoutDiscountInclVAT:selectedService[0].price,
        totalTime: selectedService[0].duration,
        isAddedFromAdmin: true,
        isAdditionalWork: true,

      });
      this.workOrderService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
      this.workOrderService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;

      this.services.forEach(x => {
        if (x.isServiceChecked) {
          this.workOrderService.appointmentJobDetailToUpdate.push({
            jobDetailsId:0,
            appointmentId: this.editAppointmentService.appointmentDetails.id,
            appointmentJobId: 0,
            costType: "Personnel",
            demandNo: 1,
            description: x.name,
            fixedPrice: x.isFixed && x.servicePrice ? x.servicePrice: null,
            id: 0,
            jobId: 1,
            plannedQuantity: 0,
            salesPart: x.serviceNo,
            salesPriceWithoutDiscount: 0,
            salesPriceWithoutDiscountInclVAT:0,
            salesPriceAmount: 0,
            salesPriceAmountVAT: 0,
            serviceId: x.id,
            unitPrice:  0,
            quantity: x.duration,
            isAddedFromAdmin: true,
            isAdditionalWork: true,
            bomTypeId: 1,
            partTotalQtyOnLocal: 0,
            partAvailableQtyOnHand: 0,
            partAvailableQtyOnCentral: 0,
            discount: null,
            discountPrice:null,
            packageNo:null,
            packageVersionNo:0,
            billToCustomer:this.contactDetails.billtoCustomerNo,
            makeCode: x.makeCode,
            costPrice:0,
            itemGroupCode:"",
            lastDirectCost:0,
            listPriceLCY:0,
            itemStatusId: 0
          });
          if(!this.empty(x.aFxPackageNo)){
            if(x.servicePackageBOM.length > 0){
              this.saveSearchedServiceBOMDetails(0,x.servicePackageBOM);
            }
          }
        }
      });
    }
    else {
      let lastDemandNoForDemand: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      lastDemandNoForDemand = lastDemandNoForDemand + 1;
      let demand = {
        id: 0,
        demandNo: +lastDemandNoForDemand,
        shortDescription: selectedService[0].name,
        customerRequirement: selectedService[0].internalDescription,
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedService[0].price,
        sumPerServiceInclTax: selectedService[0].price,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        sumPerServiceWithoutDiscountInclVAT:selectedService[0].price,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      }
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      let lastDemandNoForJob: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNoForJob,
        jobId: lastDemandNoForJob,
        description: selectedService[0].name,
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedService[0].price,
        salesPriceWithoutDiscountInclVAT:selectedService[0].price,
        totalTime: selectedService[0].duration,
        isAddedFromAdmin: true,
        isAdditionalWork: true
      });

      let lastJobList: any = this.appointmentServiceDetail.appointmentJobList[this.appointmentServiceDetail.appointmentJobList.length - 1].id;
      this.services.forEach(x => {
        if (x.isServiceChecked) {
          this.workOrderService.appointmentJobDetailToUpdate.push({
            jobDetailsId:0,
            appointmentId: this.editAppointmentService.appointmentDetails.id,
            appointmentJobId: lastJobList + 1,
            costType: "Personnel",
            demandNo: lastDemandNoForJob,
            description: x.name,
            fixedPrice: x.isFixed && x.servicePrice ? x.servicePrice: null,
            id: 0,
            jobId: lastDemandNoForJob,
            plannedQuantity: 0,
            salesPart: x.serviceNo,
            salesPriceWithoutDiscount:0,
            salesPriceWithoutDiscountInclVAT:0,
            salesPriceAmount: 0,
            salesPriceAmountVAT: 0,
            serviceId: x.id,
            unitPrice:  0,
            quantity: x.duration,
            isAddedFromAdmin: true,
            isAdditionalWork: true,
            bomTypeId: 1,
            partTotalQtyOnLocal: 0,
            partAvailableQtyOnHand: 0,
            partAvailableQtyOnCentral: 0,
            discount: null,
            discountPrice:null,
            packageNo:null,
            packageVersionNo:0,
            billToCustomer:this.contactDetails.billtoCustomerNo,
            makeCode: x.makeCode,
            costPrice:0,
            itemGroupCode:"",
            lastDirectCost:0,
            listPriceLCY:0,
            itemStatusId: 0
          });
          if(!this.empty(x.aFxPackageNo)){
            if(x.servicePackageBOM.length > 0){
              this.saveSearchedServiceBOMDetails((this.appointmentServiceDetail.appointmentJobList.length - 1),x.servicePackageBOM);
            }
          }
        }
      });
    }

    this.services.forEach(x => {
      x.isServiceChecked = false;
    })
  }

  async GetJobsDetailsList() {
    // Other option except Update Appointment on click on save
    if (!this.workOrderService.contactDetails) {
      return;
    }
    const appointmentId = this.editAppointmentService.appointmentDetails.id;
    // Guards against firing while the Save button (or another auto-save for this same
    // appointment) already has an UpdateAppointment call in flight - otherwise both requests
    // can carry the same not-yet-persisted (Id=0) demand/job/job-detail and duplicate it.
    if (this.workOrderService.isSavingAppointment(appointmentId)) {
      return;
    }
      let viewModel = this.workOrderService.MapToViewModel(false, false);
      const hasAppointmentDemand = viewModel.AppointmentDemandList?.length > 0;

      if (!hasAppointmentDemand) {
        const msg = this.translate.instant("lblJobDescNotNull");
        this.toastr.error(msg);
        return;
      }

        this.workOrderService.beginSave(appointmentId);
        this.spinner.show();
        try {
        //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
        viewModel = await this.workOrderService.GetPartCostAndItemGroupCode(viewModel,false);
        // Finish to get part price.

        await this.appointmentService.UpdateAppointment(viewModel)
          .then(async (response) => {
            if (response.responseObject.result) {
              //Show dms response failed message
              if(!this.empty(response.responseObject.result.dmsFailedMessage)){
                this.toastr.error(response.responseObject.result.dmsFailedMessage);
              }

              if(response.responseObject.result?.errorCode === Enums.ErrorCodes.DataNotFound)
              {
                this.spinner.hide();
                let errorMessage = this.translate.instant("lblAppointmentDeleted");
                this.toastr.error(errorMessage);
                return;
              }
              if (response.responseObject.result?.isAlreadyModifiedAppointment)
              {
                this.spinner.hide();
                let errorMessage = this.translate.instant("lblAppointmentAlreadyModified");
                this.toastr.error(errorMessage);
                return;
              }
                this.workOrderService.contactDetails.appointmentChangeVersion = response.responseObject.result.appointmentChangeVersion;
                this.workOrderService.contactDetails.needAttention = response.responseObject.result.needAttention;
                if (viewModel.AppointmentType == "Quote" && viewModel.WorkOrderStatusId == Enums.WOStatus.Prepared) {
                  if (response.responseObject.result.ifsWorkOrderStatusId && response.responseObject.result.appointmentStatusId) {
                    this.refreshWorkOrderData(response.responseObject.result);
                  }
                }
                // Awaited so the guard (finally block below) doesn't release until the local
                // demand/job model is actually resynced with server-assigned Ids - otherwise, on
                // a slow connection, a Save/another auto-save fired in the gap before this refresh
                // completed would still resend the stale (Id=0) demand and duplicate it.
                await this.GetAppointmentServiceDetails();

            }
            this.spinner.hide();
          }, _error => {
            this.spinner.hide();
          });
        } finally {
          this.workOrderService.endSave(appointmentId);
        }


  }

  refreshWorkOrderData(result: any) {
    this.editAppointmentService.appointmentDetails.bookedDateTime = result.bookedDateTime;
    this.editAppointmentService.appointmentDetails.workOrderStatusId = result.ifsWorkOrderStatusId;
    this.editAppointmentService.appointmentDetails.workOrderStatusColor = result.workOrderStatusColor;
    this.editAppointmentService.appointmentDetails.workOrderStatus = result.workorderStatus;
    this.editAppointmentService.appointmentDetails.appointmentStatusId = result.appointmentStatusId;
    this.editAppointmentService.appointmentDetails.appointmentStatusColor = result.appointmentStatusColor;
    this.editAppointmentService.appointmentDetails.workOrderNo = result.workOrderNumber;
    this.editAppointmentService.appointmentDetails.appointmentStatus = result.appointmentStatus;
    this.editAppointmentService.appointmentDetails.appointmentType = result.appointmentType;
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    this.appointmentDetails.bookedDateTime = this.editAppointmentService.appointmentDetails.bookedDateTime;
    this.appointmentDetails.workOrderStatusId = this.editAppointmentService.appointmentDetails.workOrderStatusId;
    this.appointmentDetails.workOrderStatusColor = this.editAppointmentService.appointmentDetails.workOrderStatusColor;
    this.appointmentDetails.workOrderStatus = this.editAppointmentService.appointmentDetails.workOrderStatus;
    this.appointmentDetails.appointmentStatusId = this.editAppointmentService.appointmentDetails.appointmentStatusId;
    this.appointmentDetails.appointmentStatusColor = this.editAppointmentService.appointmentDetails.appointmentStatusColor;
    this.appointmentDetails.workOrderNo = this.editAppointmentService.appointmentDetails.workOrderNo;
    this.appointmentDetails.appointmentType = this.editAppointmentService.appointmentDetails.appointmentType;

  }

  async DeleteAndGetJobDetails() {
    // Other option except Update Appointment on click on save
    if (this.workOrderService.contactDetails !== undefined) {
      const appointmentId = this.editAppointmentService.appointmentDetails.id;
      // Guards against firing while the Save button (or another auto-save for this same
      // appointment) already has an UpdateAppointment call in flight.
      if (this.workOrderService.isSavingAppointment(appointmentId)) {
        return;
      }
      let viewModel = this.workOrderService.MapToViewModel(true, true);
      //To Get latest itemgroup code and cost price to calculate item price changes done by dharmendra on 9 Oct 2024
      viewModel = await this.workOrderService.GetPartCostAndItemGroupCode(viewModel,false);
      // Finish to get part price.

      if (viewModel.AppointmentDemandList && viewModel.AppointmentDemandList?.length > 0) {
        this.workOrderService.beginSave(appointmentId);
        this.spinner.show();
        try {
        await this.appointmentService.UpdateAppointment(viewModel)
          .then(async (response) => {
            if (response.responseObject.result) {
              //Show dms response failed message
              if(!this.empty(response.responseObject.result.dmsFailedMessage)){
                this.toastr.error(response.responseObject.result.dmsFailedMessage);
              }
              if(response.responseObject.result?.errorCode === Enums.ErrorCodes.DataNotFound)
              {
                this.spinner.hide();
                let errorMessage = this.translate.instant("lblAppointmentDeleted");
                this.toastr.error(errorMessage);
              }
              else if (response.responseObject.result?.isAlreadyModifiedAppointment)
              {
                this.spinner.hide();
                let errorMessage = this.translate.instant("lblAppointmentAlreadyModified");
                this.toastr.error(errorMessage);
              }
              else{
                await this.GetAppointmentServiceDetails();
                this.workOrderService.contactDetails.needAttention = response.responseObject.result.needAttention;
                this.workOrderService.contactDetails.appointmentChangeVersion = response.responseObject.result.appointmentChangeVersion;
              }
            }


            this.spinner.hide();
          }, _error => {
            this.spinner.hide();
          });
        } finally {
          this.workOrderService.endSave(appointmentId);
        }
      }
    }
  }

  checkDiscount(event): void {
    const isDigit = Utility.isDigit(event);
    const isDecimalPoint = Utility.isDecimalPoint(event);
    if (!isDecimalPoint && !isDigit) {
      event.preventDefault();
    }
  }
  async getDealerService(index: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    let dateFormatRegistrationDate = Utility.getDateStringToDate(this.contactDetails.registrationDate);
    let date = new Date();
    let vehicleAge = Utility.monthDiff(dateFormatRegistrationDate, date);

    let model = {
      fuelType: this.contactDetails.engineTypeCode,
      vehicleType: this.contactDetails.vehicleTypeCode,
      brand: this.contactDetails.companyMakeCode,
      model: this.contactDetails.modelName,
      language: language,
      mileage: this.contactDetails.previousKilometer,
      vehicleAge: vehicleAge,
      dealerId: this.editAppointmentService.appointmentDetails.dealerId,
      customerNo: this.appointmentServiceDetail.appointmentDemandList.length == 0? this.contactDetails.billtoCustomerNo : this.appointmentServiceDetail.appointmentDemandList[index].billToCustomer
    }
    this.spinner.show();
    let serviceCategories = [];
    this.dealerServicesList = [];
    await this.serviceServices.GetServicesByDealerId(model).then(result => {
      this.spinner.hide();
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        serviceCategories = result.responseObject;

        if (serviceCategories.length > 0) {
          serviceCategories.forEach(element => {
            let mappedService = element.services;
            if (mappedService.length > 0) {
              mappedService.forEach(element => {
                this.dealerServicesList.push(element);
              });
            }
          });
        }
      }
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async OpenSearchPackagePopUp(index: number,isPackageAsDemand) {
    if(!isPackageAsDemand){
      if (this.empty(this.appointmentServiceDetail.appointmentDemandList[index]?.shortDescription)) {
        this.toastr.error(this.translate.instant("lblJobDescNotNull"));
        return;
      }
      let demandIndexFixed=this.getDemandIndex(index);
      if (this.secureStorage.getKeyData('ApplyDiscountOnFixedPriceReverse') == "1" && !this.empty(this.appointmentServiceDetail?.appointmentDemandList[demandIndexFixed]?.fixedPrice)) {
        let msg = this.translate.instant("lblDemandFixedPriceValidation")
        this.toastr.error(msg);
        return;
      }
    } else if (isPackageAsDemand && this.appointmentServiceDetail.appointmentDemandList?.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
   
    //in case filter is applied on demand level then job level we will always get index 0 so checked with filtered is applied at demand
    // if index 0 and filtered applied then change the index to filter applied demand for demand level index only
    const demandList = this.appointmentServiceDetail.appointmentDemandList;
    let demandIndex = index === 0 && demandList.some(x => x.isFilterSelected)
      ? demandList.findIndex(x => x.isFilterSelected)
      : index;
  
    if (this.dealerServicesList.length == 0) {
      await this.getDealerService(index);
    }
    if(localStorage.getItem("Theme") === 'mg'){
      this.partService.locationCode = this.contactDetails.dealerDmsNo;
    }else{
      this.partService.locationCode = this.contactDetails.locationCode;
    }
    this.packageService.dealerServicesList = this.dealerServicesList;
    this.packageService.UnitPriceDealer = this.editAppointmentService.appointmentDetails.unitPrice;
    this.packageService.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    this.packageService.appointmentType = this.editAppointmentService.appointmentDetails.appointmentType;
    const modalRef = this.modalService.open(SearchPackageComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.companyMakeCode = this.contactDetails.companyMakeCode;
    try {
      const result = await modalRef.result;
      // This is intentional
    } catch (reason) {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        const packageService = this.packageService;
        this.packageVersionBOM = packageService.packageVersionBOM;
        this.selectPackageMakeCode = packageService.packageMakeCode;
        this.selectPackageVersionName = packageService.packageVersionName;
        this.selectPackageSourceId = packageService.sourceId;
        this.disableShortDescriptionOnFilter = false;
        if(isPackageAsDemand){
          this.getPackageAsDemand();
          demandIndex = this.appointmentServiceDetail.appointmentDemandList.length - 1;
          index = this.appointmentServiceDetail.appointmentJobList.length - 1;
        }
        if (this.isDmsPackageSync) {
          this.selectPackageSourceId == Constant.PlannerSource ? this.saveSearchedPackageDetails(index, demandIndex, false) : this.saveSearchedPackageDetailsInDMS(index, demandIndex);
        } else {
          this.saveSearchedPackageDetails(index, demandIndex, true);
        }
      }
    }
  }

  getPackageAsDemand(){
    let selectedPackage: any = this.packageVersionBOM;
    if (this.appointmentServiceDetail.appointmentDemandList.length == 0) {
      this.appointmentServiceDetail.appointmentDemandList.push({
        id: 0,
        demandNo: 1,
        shortDescription: this.selectPackageVersionName,
        customerRequirement: '',
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedPackage[0].unitPrice,
        sumPerServiceInclTax: 0,
        sumPerServiceWithoutDiscountInclVAT:0,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      });
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: 1,
        jobId: 1,
        description: '',
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedPackage[0].unitPrice,
        salesPriceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true,
      });
     this.workOrderService.appointmentJobList = this.appointmentServiceDetail.appointmentJobList;
      this.workOrderService.appointmentDemandList = this.appointmentServiceDetail.appointmentDemandList;
    }
    else {
      let lastDemandNoForDemand: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      lastDemandNoForDemand = lastDemandNoForDemand + 1;
      let demand = {
        id: 0,
        demandNo: +lastDemandNoForDemand,
        shortDescription: this.selectPackageVersionName,
        customerRequirement: '',
        preApproval: "",
        isAddedFromAdmin: true,
        isInWarranty: false,
        isDeleted: false,
        fixedPrice: null,
        sumPerService: selectedPackage[0].unitPrice,
        sumPerServiceInclTax: selectedPackage[0].unitPrice,
        isAdditionalWork: true,
        totalPriceInclVAT: 0,
        sumPerServiceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        billToCustomer: this.contactDetails.billtoCustomerNo,
        sstOperationId : '',
        sstOperationCode: '',
        demandStaus:''
      }
      this.appointmentServiceDetail.appointmentDemandList.push(demand);
      let lastDemandNoForJob: any = this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList.length - 1].demandNo;
      this.appointmentServiceDetail.appointmentJobList.push({
        id: 0,
        demandNo: lastDemandNoForJob,
        jobId: lastDemandNoForJob,
        description: '',
        appointmentDemandId: 0,
        fixedPrice: null,
        price: selectedPackage[0].unitPrice,
        salesPriceWithoutDiscountInclVAT:selectedPackage[0].unitPrice,
        totalTime: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: true
      });
    }
  }

  async OpenSearchPartsPopUp(index: number) {
    //in case filter is applied on demand level then job level we will always get index 0 so checked with filtered is applied at demand
    // if index 0 and filtered applied then change the index to filter applied demand for demand level index only
    let demandIndex=this.getDemandIndex(index);
    if (this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription)) {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
      return;
    }
    if (this.secureStorage.getKeyData('ApplyDiscountOnFixedPriceReverse') == "1" && !this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndex].fixedPrice)) {
      let msg = this.translate.instant("lblDemandFixedPriceValidation")
      this.toastr.error(msg);
      return;
    }

    this.selectedPartList = [];
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    if(localStorage.getItem("Theme") === 'mg'){
      this.partService.locationCode = this.contactDetails.dealerDmsNo;
    }else{
      this.partService.locationCode = this.contactDetails.locationCode;
    }
      this.partService.searchPartNumber = null;
    const modalRef = this.modalService.open(SearchPartsComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.dealerId = this.contactDetails.dealerId;
    modalRef.componentInstance.selectedPartList = this.appointmentServiceDetail.appointmentJobDetailList.filter(y => y.bomTypeId == 2 && y.costType == "Material");
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.selectedPartList = this.partService.selectedPartListWithAddtionalItems;
      let partsExits = false;
      for (const item of this.selectedPartList) {
        if (this.appointmentServiceDetail.appointmentJobDetailList.findIndex(y => y.jobId == currentJobId && y.bomTypeId == 2 && y.salesPart == item.partNumber) != -1) {
          partsExits = true;
        }
      }
      if (partsExits && reason === true) {
        let laborErrorMessage = this.translate.instant("lblPartAlreadyExists");
        this.toastr.error(laborErrorMessage);
        modalRef.dismiss(true);
        this.spinner.hide();
      } else {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.disableShortDescriptionOnFilter = false;
          this.saveSearchedPartsDetails(index,demandIndex);
        }
      }
    })
  }

  getDemandIndex(index: number): number {
    if (index === 0 && this.appointmentServiceDetail.appointmentDemandList.find(x => x.isFilterSelected === true)) {
      return this.appointmentServiceDetail.appointmentDemandList.findIndex(x => x.isFilterSelected === true);
    }
    return index;
  }

  async OpenSearchLaborPopUp(index: number) {
    let demandIndex=this.getDemandIndex(index);
    if (this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription)) {
      let msg = this.translate.instant("lblJobDescNotNull")
      this.toastr.error(msg);
      return;
    }
    if (this.secureStorage.getKeyData('ApplyDiscountOnFixedPriceReverse') == "1" && !this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndex].fixedPrice)) {
      let msg = this.translate.instant("lblDemandFixedPriceValidation")
      this.toastr.error(msg);
      return;
    }
    this.selectedLaborList = [];
    let currentJobId = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    this.laborService.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    const modalRef = this.modalService.open(SearchLaborComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.companyMakeCode = this.contactDetails.companyMakeCode;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.selectedLaborList = this.laborService.selectedLaborList;
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.disableShortDescriptionOnFilter = false;
        this.saveSearchedLaborDetails(index,demandIndex);
      }
    })
  }

  async saveSearchedLaborDetails(index: number,demandIndex:number) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[demandIndex].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    this.selectedLaborList.forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId: 0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.name,
        fixedPrice: x.isFixed ? x.fixedPrice ?? null : null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.laborNo,
        salesPriceWithoutDiscount: 0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: x.duration,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount:  null,
        discountPrice: null,
        packageNo: null,
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    await this.GetJobsDetailsList()
  }

  async saveSearchedPartsDetails(index: number,demandIndex:number) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[demandIndex].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    this.selectedPartList.forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.partNumber,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice, // calculated in common method mapUpdateJobDetailViewModel.
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.qty,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.quantity,
        partAvailableQtyOnHand: x.availableQuantity,
        partAvailableQtyOnCentral: x.centralAvailableQty,
        discount: null,
        discountPrice: null,
        packageNo: null,
        packageVersionNo: 0,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        costPrice:x.unitCost,
        itemGroupCode:x.itemGroupCode,
        lastDirectCost:x.lastDirectCost,
        listPriceLCY:x.listPriceLCY,
        itemStatusId: 0
      });
    });
    await this.GetJobsDetailsList()

  }

  async saveSearchedPackageDetailsInDMS(index: number,demandIndex:number){
    if(this.empty(this.editAppointmentService.appointmentDetails.workOrderNo)){
      this.toastr.error(this.translate.instant("lblNotSyncAppointment"));
      return;
    }
    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")
    let successMessage = this.translate.instant("lblPackageAddedToDMS");
    let jobInfo = {
      appointmentId: this.editAppointmentService.appointmentDetails.id,
      dmsJobLineNo: this.appointmentServiceDetail.appointmentDemandList[demandIndex].dmsJobLineNo,
      billToCustomer: this.appointmentServiceDetail.appointmentDemandList[demandIndex].billToCustomer,
      shortDescription: this.appointmentServiceDetail.appointmentDemandList[demandIndex].shortDescription,
      fixedPrice: this.empty(this.appointmentServiceDetail.appointmentDemandList[demandIndex].fixedPrice)? this.appointmentServiceDetail.appointmentJobList[index].fixedPrice : null,
      packageNo: this.packageVersionBOM[0].packageNumber,
      packageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
      packageMakeCode: this.selectPackageMakeCode,
      customerRequirement:this.appointmentServiceDetail.appointmentDemandList[demandIndex].customerRequirement,
    }
    this.spinner.show();
    this.appointmentService.AddAppointmentJobPackageInDms(jobInfo).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        if (res.responseObject.isSuccess) {
          this.toastr.success(successMessage);
          this.GetAppointmentServiceDetails();
        } else {
          let errormsg;
          if(res.responseObject.resultMessage.includes('already exists')){
            errormsg = this.translate.instant("lblPackageAlreadyAdded");
          }else{
            errormsg = this.translate.instant("lblFailedToAddPackage");
          }
          
          this.toastr.error(errormsg);
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toastr.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        let errormsg = this.translate.instant("lblAlreadyAdded");
        this.toastr.warning(errormsg);
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toastr.warning(WarningMessage);
      }
      else {
        this.toastr.error(errorMessage);
      }
    });

  }

  async saveSearchedPackageDetails(index: number,demandIndex: number,includePackagesInJob: boolean) {
    let billToCustomer = this.appointmentServiceDetail.appointmentDemandList[demandIndex].billToCustomer;
    let demand = this.appointmentServiceDetail.appointmentJobList[index].demandNo;
    let job = this.appointmentServiceDetail.appointmentJobList[index].jobId;
    let appointmentJobId = this.appointmentServiceDetail.appointmentJobList[index].id;
    if(includePackagesInJob){
      this.appointmentServiceDetail.appointmentJobList[index].packageNo = this.packageVersionBOM[0].packageNumber;
      this.appointmentServiceDetail.appointmentJobList[index].packageVersionNo = this.packageVersionBOM[0].packageVersionNumber;
      this.appointmentServiceDetail.appointmentJobList[index].packageMakeCode = this.selectPackageMakeCode;
      this.appointmentServiceDetail.appointmentJobList[index].packageVersionName = this.selectPackageVersionName;
    }
    this.appointmentServiceDetail.appointmentJobList[index].afxPackageNo = this.packageVersionBOM[0].packageNumber;
    this.appointmentServiceDetail.appointmentJobList[index].afxPackageVersionNo = this.packageVersionBOM[0].packageVersionNumber;
    let packageNo =includePackagesInJob? this.packageVersionBOM[0].packageNumber : '';
    let packageVersionNo = includePackagesInJob? this.packageVersionBOM[0].packageVersionNumber : 0
    this.packageVersionBOM.filter(x => x.bomTypeId == 2).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Material",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 2,
        partTotalQtyOnLocal: x.totalQuantityOnLocal  ?? 0,
        partAvailableQtyOnHand: x.availableQuantity ?? 0,
        partAvailableQtyOnCentral: x.centralAvailableQty ?? 0,
        discount: null,
        discountPrice: null,
        packageNo: packageNo,
        packageVersionNo: packageVersionNo,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 1).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId ? appointmentJobId : 0,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: x.serviceId,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 1,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: packageNo,
        packageVersionNo: packageVersionNo,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 3).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "Personnel",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: x.no,
        salesPriceWithoutDiscount:x.unitPrice,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: x.unitPrice,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: x.unitPrice,
        quantity: x.quantity,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 3,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        packageNo: packageNo,
        packageVersionNo: packageVersionNo,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    this.packageVersionBOM.filter(x => x.bomTypeId == 4).forEach(x => {
      this.workOrderService.appointmentJobDetailToUpdate.push({
        jobDetailsId:0,
        appointmentId: this.editAppointmentService.appointmentDetails.id,
        appointmentJobId: appointmentJobId,
        costType: "",
        demandNo: demand,
        description: x.description,
        fixedPrice: null,
        id: 0,
        jobId: job,
        plannedQuantity: 0,
        salesPart: "",
        salesPriceWithoutDiscount:0,
        salesPriceWithoutDiscountInclVAT:0,
        salesPriceAmount: 0,
        salesPriceAmountVAT: 0,
        serviceId: 0,
        unitPrice: 0,
        quantity: 0,
        isAddedFromAdmin: true,
        isAdditionalWork: false,
        bomTypeId: 4,
        partTotalQtyOnLocal: 0,
        partAvailableQtyOnHand: 0,
        partAvailableQtyOnCentral: 0,
        discount: null,
        discountPrice: null,
        packageNo: packageNo,
        packageVersionNo: packageVersionNo,
        billToCustomer:billToCustomer,
        makeCode: x.makeCode,
        packageVersionName: this.selectPackageVersionName,
        afxPackageNo: this.packageVersionBOM[0].packageNumber,
        afxPackageVersionNo: this.packageVersionBOM[0].packageVersionNumber,
        costPrice:0,
        itemGroupCode:"",
        lastDirectCost:0,
        listPriceLCY:0,
        itemStatusId: 0
      });
    });
    await this.GetJobsDetailsList()

  }


  checkJobQty(e, _i) {
    if (e !== "") {
      this.workOrderService.demandQtyCheckflag = true;
    }
    else {
      this.workOrderService.demandQtyCheckflag = false;
    }
  }
  onBlurQuntity(e, _i){
    let plannedQuantity= JSON.parse(JSON.stringify(e.target.value));
    plannedQuantity = parseFloat(plannedQuantity.toString().replace('\u00A0', '').replace(' ','').replace(',','.'));
    this.appointmentServiceDetail.appointmentJobDetailList[_i].plannedQuantity = plannedQuantity;
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  changeFilterSelect(obj, number, fromDemand) {
    if (obj.isFilterSelected) {
      this.disableShortDescriptionOnFilter = false;
      this.selectAll = false;
      obj.isFilterSelected = false;
      this.appointmentServiceDetail.appointmentDemandList =
        this.mainAppointmentServiceDetail.appointmentDemandList;
      this.appointmentServiceDetail.appointmentDemandList.forEach(
        (obj) => (obj.isFilterSelected = false)
      );
      this.appointmentServiceDetail.appointmentJobList =
        this.mainAppointmentServiceDetail.appointmentJobList;
      this.appointmentServiceDetail.appointmentJobList.forEach(
        (obj) => (obj.isFilterSelected = false)
      );
      this.appointmentServiceDetail.appointmentJobDetailList =
        this.mainAppointmentServiceDetail.appointmentJobDetailList;
    } else {
      this.disableShortDescriptionOnFilter = true;
      obj.isFilterSelected = true;
      if (fromDemand) {
        this.appointmentServiceDetail.appointmentJobList =
          this.mainAppointmentServiceDetail.appointmentJobList.filter(
            (obj) => obj.demandNo == number
          );
        this.appointmentServiceDetail.appointmentJobList.forEach(
          (obj) => (obj.isFilterSelected = true)
        );
      }
      this.appointmentServiceDetail.appointmentJobDetailList =
        this.mainAppointmentServiceDetail.appointmentJobDetailList.filter(
          (obj) => obj.demandNo == number
        );
    }
  }

  onDemandFilterSelect(demandNo) {
    this.disableShortDescriptionOnFilter = false;
    if (this.isFirstCall <= 0) {
      this.mainAppointmentServiceDetail = Object.assign({}, this.appointmentServiceDetail);
      this.isFirstCall += 1;
    }
    this.appointmentServiceDetail.appointmentDemandList.forEach((obj) => {
      if (obj.demandNo == demandNo) {
        this.changeFilterSelect(obj, demandNo, true);
      } else {
        obj.isFilterSelected = false;
      }
    });
  }
  onJobFilterSelect(jobNo) {
    if (this.isFirstCall <= 0) {
      this.mainAppointmentServiceDetail = Object.assign({}, this.appointmentServiceDetail);
      this.isFirstCall += 1;
    }
    this.appointmentServiceDetail.appointmentJobList.forEach((obj) => {
      if (obj.jobId == jobNo) {
        this.changeFilterSelect(obj, jobNo, false);
      } else {
        obj.isFilterSelected = false;
      }
    });
  }

  mapIndexWithJobDetails() {
    let index = 1;
    let demand = 1;
    this.appointmentServiceDetail.appointmentJobDetailList.forEach((jobDetails) => {
      if (jobDetails.jobId == jobDetails.demandNo && jobDetails.demandNo == demand) {
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      } else {
        index = 1;
        jobDetails.jobDetailsId = index;
        demand = jobDetails.demandNo;
        index++;
      }
    })
  }

  changeJobDetailToPrevious(jobdetail) {
    let index = this.appointmentServiceDetail.appointmentJobList.findIndex(x => x.jobId == jobdetail.jobId)
    if (index > 0) {
      let data = this.appointmentServiceDetail.appointmentJobList.filter(x => x.jobId == (jobdetail.jobId - 1))[0].id
      let model = {
        appointmentJobDetailIdToMove: jobdetail.id,
        appointmentJobId: data,
        appointmentId: jobdetail.appointmentId,
        serviceNo: jobdetail.salesPart,
        integrationWithDms:this.isDMSEnable,
        languageCode:this.currentLanguage
      }
      this.appointmentService.MoveRequestForJobDetails(model).then((res) => {
        if (res.responseCode == Enums.ErrorCodes.SuccessCode) {
          this.GetAppointmentServiceDetails();
        }
      })
    }
  }

  changeJobDetailToNext(jobdetail) {
    let Index = this.appointmentServiceDetail.appointmentJobList.findIndex(x => x.jobId == jobdetail.jobId)
    if (Index < (this.appointmentServiceDetail.appointmentJobList.length - 1)) {
      let data = this.appointmentServiceDetail.appointmentJobList.filter(x => x.jobId == (jobdetail.jobId + 1))[0].id
      let model = {
        appointmentJobDetailIdToMove: jobdetail.id,
        appointmentJobId: data,
        appointmentId: jobdetail.appointmentId,
        serviceNo: jobdetail.salesPart,
        integrationWithDms:this.isDMSEnable,
        languageCode:this.currentLanguage
      }
      this.appointmentService.MoveRequestForJobDetails(model).then((res) => {
        if (res.responseCode == Enums.ErrorCodes.SuccessCode) {
          this.GetAppointmentServiceDetails();
        }
      })
    }
  }

  onSelectAllDemand(isSelectAll: boolean) {
    if (this.isFirstCall <= 0) {
      this.mainAppointmentServiceDetail = Object.assign({}, this.appointmentServiceDetail);
      this.isFirstCall += 1;
    }
    this.selectAll = isSelectAll;
    this.appointmentServiceDetail.appointmentJobList =
      this.mainAppointmentServiceDetail.appointmentJobList;
    this.appointmentServiceDetail.appointmentJobDetailList =
      this.mainAppointmentServiceDetail.appointmentJobDetailList;
    this.addFilterSelectedVariable(isSelectAll);
  }

  async onRefreshStock() {
    if (this.appointmentServiceDetail.appointmentJobDetailList.length == 0) {
      return;
    }
    if(localStorage.getItem("Theme") === 'mg'){
      let model : any = {}
      let partArray : PartNumberMultiInventeryModel[] = [];

      this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
        if (obj.costType == "Material") {
          let part : PartNumberMultiInventeryModel = {part_number : obj.salesPart};
          partArray.push(part);
        }
      });
      model.af_dealerid = this.contactDetails.dealerDmsNo,
      model.parts = partArray;
      this.spinner.show();
      await this.partService.GetMultiInventoryParts(model).then(response => {
        this.spinner.hide();
        this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
          if (obj.costType == "Material") {
             obj.partAvailableQtyOnCentral = response.find(f=>f.partNumber == obj.salesPart).centralAvailableQuantity;
             obj.partAvailableQtyOnHand = response.find(f=>f.partNumber == obj.salesPart).onHandQuantity;
             obj.partTotalQtyOnLocal = response.find(f=>f.partNumber == obj.salesPart).localQuantity;
          }
        });
      });

    }else if(localStorage.getItem("Theme") === 'bnh'){
      let model : any = {}
      let partArray : ItemStatusServicesModel[] = [];

      this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
        if (obj.costType == "Material" && !this.empty(obj.dmsLineNo)) {
          let part : ItemStatusServicesModel = {serviceLineNo : obj.dmsLineNo};
          partArray.push(part);
        }
      });
      model.serviceOrderNo = this.contactDetails.workOrderNo,
      model.serviceLines = partArray;
      if(partArray.length == 0){
        return;
      }
      this.spinner.show();
      await this.partService.GetItemStatusAndInventoryList(model).then(response => {
        this.spinner.hide();
        this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
          if (obj.costType == "Material") {
             obj.partAvailableQtyOnCentral = response.find(f=>f.serviceLineNo == obj.dmsLineNo).centralAvailableQuantity;
             obj.partAvailableQtyOnHand = response.find(f=>f.serviceLineNo == obj.dmsLineNo).onHandQuantity;
             obj.partTotalQtyOnLocal = response.find(f=>f.serviceLineNo == obj.dmsLineNo).localQuantity;
             obj.itemStatusId = response.find(f=>f.serviceLineNo == obj.dmsLineNo).availabilityStatus;
             obj.itemStatusName = response.find(f=>f.serviceLineNo == obj.dmsLineNo).availabilityStatusMessage;
          }
        });
      });

    }
    else{
      this.appointmentServiceDetail.appointmentJobDetailList.forEach(async (obj) => {
        if (obj.costType == "Material") {
          this.spinner.show();
          let model =   {
            locationCode: this.contactDetails.locationCode,
            no: obj.salesPart,
            languageCode: this.cookieservice.get('userSelectedLanguage')
          }
          await this.partService.GetInventoryParts(model).then(response => {
            this.spinner.hide();
            obj.partAvailableQtyOnCentral = response.centralAvailableQuantity;
            obj.partAvailableQtyOnHand = response.onHandQuantity;
            obj.partTotalQtyOnLocal = response.localQuantity;
          });
        }
      });
    }
  }
  async getAlternatePart(i) {
    let partNumber = this.workOrderService.appointmentJobDetailToUpdate[i].salesPart;
    this.partService.searchPartNumber = partNumber;

    const modalAlterRef = this.modalService.open(SearchAlternatePartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalAlterRef.result.then((_result) => {
      // This is intentional
     }, (response) => {
      this.popupCloseResult = this.getDismissReason(response);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.updateSearchedAlterPartsDetails(i);
          modalAlterRef.dismiss(true);
        }
      }
    })
  }

  async updateSearchedAlterPartsDetails(index: number) {
    this.workOrderService.appointmentJobDetailToUpdate[index].salesPart = this.partService.selectedPartListWithAddtionalItems[0].partNumber;
    this.workOrderService.appointmentJobDetailToUpdate[index].description = this.partService.selectedPartListWithAddtionalItems[0].description;
    this.workOrderService.appointmentJobDetailToUpdate[index].salesPriceAmount = this.partService.selectedPartListWithAddtionalItems[0].unitPrice;
    this.workOrderService.appointmentJobDetailToUpdate[index].unitPrice = this.partService.selectedPartListWithAddtionalItems[0].unitPrice;
    this.workOrderService.appointmentJobDetailToUpdate[index].quantity = this.partService.selectedPartListWithAddtionalItems[0].qty;
    this.workOrderService.appointmentJobDetailToUpdate[index].partTotalQtyOnLocal = this.partService.selectedPartListWithAddtionalItems[0].quantity;
    this.workOrderService.appointmentJobDetailToUpdate[index].partAvailableQtyOnHand = this.partService.selectedPartListWithAddtionalItems[0].availableQuantity;
    this.workOrderService.appointmentJobDetailToUpdate[index].partAvailableQtyOnCentral = this.partService.selectedPartListWithAddtionalItems[0].centralAvailableQty;
    this.workOrderService.appointmentJobDetailToUpdate[index].costPrice = this.partService.selectedPartListWithAddtionalItems[0].unitCost;
    this.workOrderService.appointmentJobDetailToUpdate[index].itemGroupCode = this.partService.selectedPartListWithAddtionalItems[0].itemGroupCode;
    this.partService.selectedPartListWithAddtionalItems = [];
    this.partService.searchPartNumber = '';
    await this.GetJobsDetailsList()
  }

  getReplacementPart(i) {
    let partNumber = this.workOrderService.appointmentJobDetailToUpdate[i].salesPart;
    this.partService.searchPartNumber = partNumber;
    this.partService.locationCode = this.contactDetails.locationCode;
    const modalAlterRef = this.modalService.open(SearchReplacementPartsComponent, {
      windowClass: 'pop-wid1000 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });

    modalAlterRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        if (this.partService.selectedPartListWithAddtionalItems.length > 0) {
          this.updateSearchedAlterPartsDetails(i);
          modalAlterRef.dismiss(true);
        }
      }
    })
  }

  //#region Warranty Document
  onInWarrantyChange(event, idx){
    if (this.isWarrantyDocumentSigned) {
      event.preventDefault();
      let modelHeadermsg = this.translate.instant("lblDocumentAlreadySigned");
      let modelBodymsg = event.currentTarget.checked ? this.translate.instant("lblWarrantyCanNotChange") : this.translate.instant("lblWarrantyCanNotRemove");
      const modalRef = this.modalService.open(NgInfoModalContent, { size: 'lg' });
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
    }
    else{
      this.checkWarranty(idx);
    }
  }
  async GetWarrantyDocumentStatus() {
    await this.documentService.GetPendingSignDocument(this.editAppointmentService.appointmentDetails.workOrderNo).then((res) => {
      this.workOrderService.isWarrantyDocumentGenerated = !!(res.responseObject?.pendingDocs != null && res.responseObject?.pendingDocs != undefined);
    });

    await this.documentService.WarrantyDocumentStatus(this.editAppointmentService.appointmentDetails.workOrderNo, this.editAppointmentService.appointmentDetails.dealerId).then(
      (res) => {
        this.isWarrantyDocumentSigned = res.responseObject;
        this.workOrderService.isWarrantyDocumentSigned = res.responseObject;
      }
    ); 
  }
  //#endregion
  //#region view demand wise document model
  ViewDocument(demand){
    if(demand?.docCount > 0){
      this.viewDemandDocument.demandNo = demand.demandNo;
      this.viewDemandDocument.demandName = demand.shortDescription;
      this.viewDemandDocument.demandId = demand.id;
      const modalref = this.modalService.open(ViewUploadedDocumentComponent, { size: 'lg' , windowClass: 'pop-wid1200 pop-hig80vh pop-mh80' });
      modalref.componentInstance.viewDemandDocument = this.viewDemandDocument;
      modalref.componentInstance.requestApplication = Enums.Application.Admin;
      modalref.componentInstance.apiBaseUrl = `${environment.ADMIN_API_URL}Document`;
      modalref.result.then((response) => {
        demand.docCount = this.GetDemandDocCount(demand);
      })
     }
 else{
   let msg = this.translate.instant("lblNoDocumentUploaded")
   this.toastr.error(msg);
 }
  }

  async OpenModel(demand:any){
    if(demand?.id != null && demand?.id != undefined && demand?.id != 0 && (this.workOrderService?.appointmentJobDetailList?.filter(x => x.demandNo == demand?.demandNo)?.length > 0) || (this.workOrderService?.appointmentJobDetailToUpdate?.filter(x => x.demandNo == demand?.demandNo)?.length > 0)){
      const modalref = this.modalService.open(UploadDocumentComponent, { size: 'lg' });
      modalref.componentInstance.uniqueId = demand?.id;
      modalref.result.then((response) => {
        if(response.success){
        const doc = this.commonService.getDocument(demand?.id);
        doc.forEach(d => {
          d.appointmentId = this.editAppointmentService.appointmentDetails.id
        });
        this.spinner.show();
        this.appointmentService.UploadDocumentFromPlanner(doc).then(async (response) => {
            if(response?.responseObject){
              let msg = this.translate.instant("lblDocumentUploadedSuccessfully")
              this.toastr.success(msg);
              this.commonService.removeDocument(demand?.id);
              await this.appointmentService.GetDocumentCount(this.editAppointmentService.appointmentDetails.id).then((res) => {
                if (res?.responseObject?.length > 0) {
                  this.editAppointmentService.DemandWiseDocumentCountList = res.responseObject;
                }
              });
              this.spinner.hide();    
            }
        }, _error => {
          this.spinner.hide()
        });
      }
      }, _error => { 
      
      });
    }
    else{
      let msg = this.translate.instant("lblAddJobDetailsToUploadDoc")
      this.toastr.error(msg);
    }

  }
  GetDemandDocCount(demand){
    const count = Object.values(this.editAppointmentService.DemandWiseDocumentCountList || {})?.find(x=>x.demandId == demand.id)?.docCount ?? 0;
    const totalCount = count;
    demand.docCount = totalCount
    return totalCount;  
  }
  
  openUpdateJob(content,job)
  {
    this.updateJobStatus(job);
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  updateJobStatus(job)
  {
    this.appointmentDemandId = job?.id;
    this.jobNo = job?.demandNo;
    this.jobDescription = job?.shortDescription;
    if(job.demandStatus == Enums.jobStatus.Pending)
    {
      this.jobShowStatus = Enums.jobStatus.Pending;
      this.jobStatus = 1;
    }
    else if(job.demandStatus == Enums.jobStatus.InProgress)
    {
      this.jobShowStatus = Enums.jobStatus.InProgress;
      this.jobStatus = 2;
    }
    else
    {
      this.jobShowStatus = Enums.jobStatus.Completed;
      this.jobStatus = 3;
    }
  }
  async updateDemandStatus()
  {
    this.spinner.show();
    let updateModel = {
      appointmentDemandId:Number(this.appointmentDemandId),
      jobStatusId:Number(this.jobStatus),
      appointmentGUID:this.editAppointmentService.appointmentDetails.appointmentGuid,
      job:this.jobDescription,
      jobNo:this.jobNo
    }
    this.service.updateJobStatus(updateModel).then(res=>{
      if(res.status == 1)
      {
        document.getElementById("modelButton").click();
        let SuccessMessage = this.translate.instant("lblJobStatusUpdated");
        this.toastr.success(SuccessMessage);
        this.GetAppointmentServiceDetails();
      }
      else
      {
        document.getElementById("modelButton").click();
      }
    })
    this.spinner.hide();
  }
  ChangeJobStatusValue(event:any)
  {
    this.jobStatus = event.target.value;
  }
  //#endregion

  openSplitOrderPopup()
  {
    this.isAllSelectedForSplit = false;
    this.splitDemandsSelection();
    this.splitOrderModalRef = this.modalService.open(this.splitOrderPopupContent, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
    this.splitOrderInstance = this.splitOrderModalRef.result.then((result) => {
    }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  splitDemandsSelection() {
    if(this.isWarrantyDocumentSigned){
      this.appointmentServiceDetail?.appointmentDemandList?.filter(x => x && x.isInWarranty === false).forEach(x => x.isSelected = this.isAllSelectedForSplit)
    }
    else{
      this.appointmentServiceDetail?.appointmentDemandList?.forEach(x => x.isSelected = this.isAllSelectedForSplit);
    }
  }

  demandSelectionChanged() {
    let isAllSelected = true;
    this.appointmentServiceDetail?.appointmentDemandList.every(x => {
        isAllSelected = x.isSelected ?? false;
        if (!isAllSelected) {
          return false;
        }
        return true;
      });
    this.isAllSelectedForSplit = isAllSelected;
  }

  public get isAppointmentSplitDemandList(){
    let count;
    if (this.isWarrantyDocumentSigned) {
      count = this.appointmentServiceDetail?.appointmentDemandList?.filter(x => x && x.isInWarranty === false).length;
    }
    else {
      count = this.appointmentServiceDetail?.appointmentDemandList?.length;
    }
    return count;
  }

  createNewOrder(splitOrderDemands) {
    if (this.isWarrantyDocumentSigned) {
      this.appointmentSplitDemandList = this.appointmentServiceDetail.appointmentDemandList.filter(x => x && x.isInWarranty === false);
    }
    else {
      this.appointmentSplitDemandList = this.appointmentServiceDetail.appointmentDemandList;
    }
    if (this.appointmentSplitDemandList && this.appointmentSplitDemandList.length > 0 && this.empty(this.appointmentServiceDetail.appointmentDemandList[this.appointmentServiceDetail.appointmentDemandList?.length - 1]?.shortDescription)) {
      let msg = this.translate.instant("lblShortDescriptionNotNull");
      this.toastr.error(msg);
      return;
    }
    this.splitOrderModalRef = this.modalService.open(splitOrderDemands, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
    this.splitOrderModalRef.result.then((result) => {
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  createQuoteFromDemand() {
    const demandsToBeSplit = this.appointmentServiceDetail?.appointmentDemandList.filter(x => x.isSelected);
    if (demandsToBeSplit.length == 0) {
      return;
    }
    let modelHeadermsg = this.translate.instant("lblConvertToQuote");
    let modelBodymsg = this.translate.instant("lblConvertToQuoteMessage");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      if (reason) {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          let demandViewModel = this.workOrderAdditionalService.mapUpdateDemandViewModel(demandsToBeSplit, false);
          this.spinner.show();
          let viewModel = {
            refAppointmentId: this.editAppointmentService.appointmentDetails.id,
            IFSWorkOrderNumber: this.editAppointmentService.appointmentDetails.workOrderNo,
            customerDefaultLanguage: this.cookieservice.get('userSelectedLanguage'),
            appointmentDemandList: demandViewModel,
          }
          this.appointmentService.AddAppointmentAsQuoteFromDemand(viewModel).then(res => {
            if (res.responseCode === Constant.SuccessResponseCode) {
              this.spinner.hide();
              let successMessage = this.translate.instant("lblAppointmentCreated");
              this.toastr.success(successMessage);
              let modelHeadermsg = this.translate.instant("lblOpenNewApointment");
              let modelBodymsg = this.translate.instant("lblOpenNewCreatedWorkOrder");
              const modalRef = this.modalService.open(NgbdModalContent);
              modalRef.componentInstance.modelHeader = modelHeadermsg;
              modalRef.componentInstance.modelBody = modelBodymsg;
              modalRef.result.then((_result) => {
                // This is intentional
              }, async (reason) => {
                if (reason) {
                  this.modalService.dismissAll();
                  this.multiStackPopupService.OpenAppointment(res.responseObject, false, false, this.editAppointmentService.appointmentDetails.id);
                }
                else{
                  this.splitOrderModalRef?.close();
                  this.editAppointmentService.isRefreshFromCreateQuote.next(true);
                }
              });
            }
            else {
              this.spinner.hide();
              let errorMessage = this.translate.instant("lblErrorMessage");
              this.toastr.error(errorMessage);
            }
          }).finally(() => {
            this.spinner.hide();
          });
        }
      }
    });
  }

  splitOrder() {
    const demandsToBeSplit = this.appointmentServiceDetail?.appointmentDemandList.filter(x => x.isSelected);
    if (demandsToBeSplit.length == 0) {
      return;
    }
    let modelHeadermsg = this.editAppointmentService.appointmentDetails?.appointmentTypeId !== 1 ? this.translate.instant("lblSplitQuote") :
                    this.translate.instant("lblSplitOrder");
    let modelBodymsg = this.translate.instant("lblCreateNewOrder");
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      if (reason) {
        let demandViewModel = this.workOrderService.mapUpdateDemandViewModel(demandsToBeSplit, false);
        let jobViewModel: any[] = [];
        demandsToBeSplit.forEach(demand => {
          let jobdetails = this.workOrderService.mapUpdateJobDetailViewModel(this.appointmentServiceDetail.appointmentJobDetailList.filter(x => x.demandNo === demand.demandNo));
          if (jobdetails) {
            jobdetails.forEach(jobDetail => {
              jobViewModel.push(jobDetail);
            });
          }
        });
        this.spinner.show();
        let viewModel = {
          refAppointmentId: this.editAppointmentService.appointmentDetails.id,
          IFSWorkOrderNumber: this.editAppointmentService.appointmentDetails.workOrderNo,
          customerDefaultLanguage: this.cookieservice.get('userSelectedLanguage'),
          appointmentDemandList: demandViewModel,
          appointmentJobDetailsList: jobViewModel,
        }
        this.appointmentService.SplitDemandsFromExistingAppointment(viewModel).then(res => {
          if (res.responseCode === Constant.SuccessResponseCode) {
            this.spinner.hide();
            let successMessage = this.translate.instant("lblAppointmentCreated");
            this.toastr.success(successMessage);
            let modelHeadermsg = this.translate.instant("lblOpenNewApointment");
            let modelBodymsg = this.translate.instant("lblOpenNewCreatedWorkOrder");
            const modalRef = this.modalService.open(NgbdModalContent);
            modalRef.componentInstance.modelHeader = modelHeadermsg;
            modalRef.componentInstance.modelBody = modelBodymsg;
            modalRef.result.then((_result) => {
              // This is intentional
            }, (reason) => {
              if(reason){
                this.modalService.dismissAll();
                this.multiStackPopupService.OpenAppointment(res.responseObject, false, false, this.editAppointmentService.appointmentDetails.id);
              }
              else{
                this.splitOrderModalRef?.close();
                this.editAppointmentService.isRefreshFromCreateQuote.next(true);
              }  
            });
          }
          else {
            this.spinner.hide();
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }
        }).finally(() => {
          this.spinner.hide();
        });
      }
    });
  }
  //#endregion
}
